export default __webpack_public_path__ + "static/media/a037-student-t3-s3-10.a8f67b57.svg";